


// import React from "react";
// import { Typography, Grid, Box } from "@mui/material";
// import { DataGrid, GridColDef } from "@mui/x-data-grid";
// import StatsCard from "./Cards/StatsCard";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import TrendingDownIcon from "@mui/icons-material/TrendingDown";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// export interface AccountRow {
//   accountId: string;
//   name: string;
//   totalCredit: number;
//   totalDebit: number;
//   netAmount: number;
// }

// interface ProfitLossContentProps {
//   totalRevenue: number;
//   totalExpenses: number;
//   netProfit: number;
//   incomeRows: AccountRow[];
//   expenseRows: AccountRow[];
// }

// const ProfitLossContent: React.FC<ProfitLossContentProps> = ({
//   totalRevenue,
//   totalExpenses,
//   netProfit,
//   incomeRows,
//   expenseRows,
// }) => {
//   const columns: GridColDef[] = [
//     { field: "name", headerName: "Account Name", flex: 1 },
//     { field: "totalCredit", headerName: "Total Credit", flex: 1 },
//     { field: "totalDebit", headerName: "Total Debit", flex: 1 },
//     { field: "netAmount", headerName: "Net Amount", flex: 1 },
//   ];
//   const revenuePerc = totalRevenue > 0 ? (totalRevenue / totalRevenue) * 100 : 0;
//   const expensePerc = totalRevenue > 0 ? (totalExpenses / totalRevenue) * 100 : 0;
//   const netProfitPerc = totalRevenue > 0 ? (netProfit / totalRevenue) * 100 : 0;


//   return (
//     <Box sx={{ p: 3 }}>

//       {/* Stats Cards */}
//       <Box display="flex" gap={3} flexWrap="wrap" mb={3}>
//         <StatsCard
//           title="Total Revenue"
//           icon={<AttachMoneyIcon />}
//           value={totalRevenue.toFixed(2)}
//           percentage={revenuePerc}
//         />

//         <StatsCard
//           title="Total Expenses"
//           icon={<TrendingDownIcon />}
//           value={totalExpenses.toFixed(2)}
//           percentage={expensePerc}
//         />

//         <StatsCard
//           title="Net Profit"
//           icon={<AccountBalanceIcon />}
//           value={netProfit.toFixed(2)}
//           percentage={netProfitPerc}
//         />
//       </Box>

//       {/* Income Table */}
//       <Typography variant="h6" sx={{ mb: 1 }}>
//         Income Accounts
//       </Typography>

//       <Box sx={{ height: 300, width: "100%", mb: 3 }}>
//         <DataGrid
//           rows={incomeRows.map((r, i) => ({ ...r, id: i }))}
//           columns={columns}
//           pageSizeOptions={[5, 10]}
//         />
//       </Box>

//       {/* Expense Table */}
//       <Typography variant="h6" sx={{ mb: 1 }}>
//         Expense Accounts
//       </Typography>

//       <Box sx={{ height: 300, width: "100%" }}>
//         <DataGrid
//           rows={expenseRows.map((r, i) => ({ ...r, id: i }))}
//           columns={columns}
//           pageSizeOptions={[5, 10]}
//         />
//       </Box>

//     </Box>
//   );
// };
// export default ProfitLossContent;



import React from "react";
import {
  Typography,
  Grid,
  Box,
  Button,
  Tooltip
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import StatsCard from "./Cards/StatsCard";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DownloadIcon from "@mui/icons-material/Download";

export interface AccountRow {
  accountId?: string;
  name: string;
  totalCredit: number;
  totalDebit: number;
  netAmount: number;
}

interface ProfitLossContentProps {
  totalRevenue: number;
  totalExpenses: number;
  netProfit: number;
  incomeRows: AccountRow[];
  expenseRows: AccountRow[];
}

const ProfitLossContent: React.FC<ProfitLossContentProps> = ({
  totalRevenue,
  totalExpenses,
  netProfit,
  incomeRows,
  expenseRows,
}) => {

  const columns: GridColDef[] = [
    { field: "name", headerName: "Account Name", flex: 1 },
    { field: "totalCredit", headerName: "Total Credit", flex: 1 },
    { field: "totalDebit", headerName: "Total Debit", flex: 1 },
    { field: "netAmount", headerName: "Net Amount", flex: 1 },
  ];

  const revenuePerc = totalRevenue > 0 ? Number(((totalRevenue / totalRevenue) * 100).toFixed(2)) : 0;
  const expensePerc = totalRevenue > 0 ? Number(((totalExpenses / totalRevenue) * 100).toFixed(2)) : 0;
  const netProfitPerc = totalRevenue > 0 ? Number(((netProfit / totalRevenue) * 100).toFixed(2)) : 0;

  const csvEscape = (value: any) => {
    if (value === null || value === undefined) return "";
    const str = String(value);
    const escaped = str.replace(/"/g, '""');
    if (/[,"\n]/.test(escaped)) {
      return `"${escaped}"`;
    }
    return escaped;
  };

  const downloadCSV = () => {
    const headers = ["Account Name","Total Credit","Total Debit","Net Amount","Type"];
    const rows: string[] = [];

    incomeRows.forEach(r => {
      rows.push([csvEscape(r.name),csvEscape(r.totalCredit),csvEscape(r.totalDebit),csvEscape(r.netAmount),"Income"].join(","));
    });

    expenseRows.forEach(r => {
      rows.push([csvEscape(r.name),csvEscape(r.totalCredit),csvEscape(r.totalDebit),csvEscape(r.netAmount),"Expense"].join(","));
    });

    const csvContent = [headers.join(","), ...rows].join("\r\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "profit_loss.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box display="flex" gap={3} flexWrap="wrap" mb={3} p={1}>
        <StatsCard title="Total Revenue" icon={<AttachMoneyIcon />} value={totalRevenue.toFixed(2)} percentage={revenuePerc}/>
        <StatsCard title="Total Expenses" icon={<TrendingDownIcon />} value={totalExpenses.toFixed(2)} percentage={expensePerc}/>
        <StatsCard title="Net Profit" icon={<AccountBalanceIcon />} value={netProfit.toFixed(2)} percentage={netProfitPerc}/>
      </Box>

      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h6">Income Accounts</Typography>

        <Tooltip title="Download CSV">
          <Button variant="outlined" size="small" startIcon={<DownloadIcon />} onClick={downloadCSV}></Button>
        </Tooltip>
      </Box>

      <Box sx={{ height: 300, width: "100%", mb: 3 }}>
        <DataGrid rows={incomeRows.map((r, i) => ({ ...r, id: i }))} columns={columns} pageSizeOptions={[5, 10]}/>
      </Box>

      <Typography variant="h6" sx={{ mb: 1 }}>Expense Accounts</Typography>

      <Box sx={{ height: 300, width: "100%" }}>
        <DataGrid rows={expenseRows.map((r, i) => ({ ...r, id: i }))} columns={columns} pageSizeOptions={[5, 10]}/>
      </Box>
    </Box>
  );
};

export default ProfitLossContent;
